import React from 'react';
import { Button, SplitButton } from '@chatsdet/ui';
import { CopySimple } from '@phosphor-icons/react';

export const CopyDropdown: React.FC<{
  items: Array<{ label: string; value: string }>;
  onCopy: (text: string, message: string) => Promise<void>;
}> = ({ items, onCopy }) => {
  if (items.length === 0) return null;
  if (items.length === 1) {
    return (
      <Button
        variant="secondary"
        size="sm"
        iconLeft={<CopySimple size={14} />}
        onPress={() => onCopy(items[0].value, items[0].label.replace('Copy ', 'Copied '))}
      >
        {items[0].label}
      </Button>
    );
  }

  return (
    <SplitButton
      variant="secondary"
      size="sm"
      iconLeft={<CopySimple size={14} />}
      onPress={() => onCopy(items[0].value, items[0].label.replace('Copy ', 'Copied '))}
    >
      {items[0].label}
      {items.map((item) => (
        <SplitButton.Item
          key={item.label}
          onAction={() => onCopy(item.value, item.label.replace('Copy ', 'Copied '))}
        >
          {item.label}
        </SplitButton.Item>
      ))}
    </SplitButton>
  );
};
